import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { LenguageTabla } from "../../Comunes/LenguajeTabla/LenguajeTabla";
import moment from "moment";
import $ from "jquery";
import { Notificar } from "../../Comunes/Notificador";
import ModificarMotivoLiquidacionModal from "./ModificarCuentasPorCobrarModal";

function OperacionesCambioCuentasPorCobrar({
  operaciones,
  actualizarOperaciones = null,
  permiteSeleccionar = false,
  permiteEditar = false,
  permiteEliminar = false,
  soloLectura = false,
}) {
  const tableRef = useRef();

  useEffect(() => {
    const botonesTabla = permiteSeleccionar ? ["selectAll", "selectNone"] : [];
    const posicionDom = permiteSeleccionar
      ? '<"mb-3"B><"float-left"l><"text-right"f>rt<"float-left"i><"text-right"p>'
      : '<"float-left"l><"text-right"f>rt<"float-left"i><"text-right"p>';

    const tabla = $(tableRef.current).DataTable({
      language: LenguageTabla,
      paging: !permiteEditar,
      pagingType: "full_numbers",
      processing: true,
      destroy: true,
      data: operaciones,
      select: permiteSeleccionar && {
        style: "multi",
        selector: "td:first-child",
      },
      dom: posicionDom,
      buttons: botonesTabla,
      columns: [
        {
          title: "Selecionar",
          data: null,
        },
        {
          title: "Operación",
          data: "operacion",
        },
        {
          title: "Periodo",
          data: "fechaPeriodo",
          render: function (row) {
            return row !== null ? moment(row).format("DD/MM/YYYY") : "";
          },
        },
        {
          title: "Cuenta Contable",
          data: "cuentaContable",
        },
        {
          title: "Saldo Cuentas Por Cobrar",
          data: "saldoCuentaPorCobrarReportado",
        },
        {
          title: "Días de Atraso",
          data: "diasAtrasoReportado",
        },
        {
          title: "Saldo Propuesto",
          data: null,
          render: function (row) {
            if (permiteEditar) {
              return row.saldoCuentaPorCobrarPropuesto == null
                ? row.tipoAccion === "E"
                  ? `<h6><span className="badge badge-secondary">Eliminar</span></h6>`
                  : `<small className="text-muted">Sin asignar</small>`
                : row.saldoCuentaPorCobrarPropuesto;
            } else if (soloLectura) {
              return row.saldoCuentaPorCobrarPropuesto == null ||
                row.tipoAccion === "E"
                ? ""
                : row.saldoCuentaPorCobrarPropuesto;
            }
            return row.saldoCuentaPorCobrarPropuesto;
          },
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Días Propuestos",
          data: null,
          render: function (row) {
            if (permiteEditar) {
              return row.diasAtrasoPropuesto == null
                ? row.tipoAccion === "E"
                  ? `<h6><span className="badge badge-secondary">Eliminar</span></h6>`
                  : `<small className="text-muted">Sin asignar</small>`
                : row.diasAtrasoPropuesto;
            } else if (soloLectura) {
              return row.diasAtrasoPropuesto == null || row.tipoAccion === "E"
                ? ""
                : row.diasAtrasoPropuesto;
            }
            return row.diasAtrasoPropuesto;
          },
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Tipo de Acción",
          data: null,
          createdCell: function (cell, cellData, rowData, rowIndex, colIndex) {
            function actualizarCuentaPorCobrar(operacion) {
              tabla.row(rowIndex).data(operacion).draw(false);
              actualizarOperaciones(tabla.rows().data().toArray());
            }

            ReactDOM.render(
              <div className="d-flex justify-content-between">
                {rowData.tipoAccion === "E" && !soloLectura ? (
                  <h6>
                    <span className="badge badge-secondary">Eliminar</span>
                  </h6>
                ) : (
                  rowData.nombreTipoAccion
                )}

                {permiteEditar ? (
                  <div className="mr-4">
                    <ModificarMotivoLiquidacionModal
                      CuentasAtrasadas={cellData}
                      actualizarCuentaPorCobrar={actualizarCuentaPorCobrar}
                    />
                    <button
                      className="btn btn-outline-danger btn-xs js-eliminar-cuentaAtrasada ml-2"
                      title="Eliminar"
                    >
                      <i className="fas fa-times-circle"></i>
                    </button>
                  </div>
                ) : null}
              </div>,
              cell
            );
          },
          searchable: false,
          orderable: false,
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Excluir de Solicitud",
          data: null,
          defaultContent:
            "<button class='btn btn-danger btn-sm js-eliminar'><i class='fa fa-trash'></i></button>",
          searchable: false,
          orderable: false,
          visible: permiteEliminar,
        },
      ],
      columnDefs: [
        {
          targets: 0,
          defaultContent: "",
          className: "select-checkbox",
          searchable: false,
          orderable: false,
          visible: permiteSeleccionar,
        },
      ],
    });

    tabla.off("click");

    tabla.on("select deselect", function (e) {
      actualizarOperaciones(tabla.rows({ selected: true }).data().toArray());
    });

    tabla.on("click", ".js-eliminar", function () {
      if (tabla.rows().data().count() === 1) {
        Notificar(
          "error",
          "No se puede eliminar. La solicitud debe tener al menos una operación."
        );
        return;
      }

      tabla.row($(this).parents("tr")).remove().draw();
      actualizarOperaciones(tabla.rows().data().toArray());
    });

    tabla.on("click", ".js-eliminar-cuentaAtrasada", function () {
      const tr = $(this).closest("tr");
      let rowData = tabla.row(tr).data();
      rowData.tipoAccion = "E";
      rowData.saldoCuentaPorCobrarPropuesto = null;
      rowData.diasAtrasoPropuesto = null;

      tabla.row(tr).data(rowData).draw(false);
      actualizarOperaciones(tabla.rows().data().toArray());
    });
  }, [
    operaciones,
    actualizarOperaciones,
    permiteSeleccionar,
    permiteEditar,
    permiteEliminar,
    soloLectura,
  ]);

  return (
    <div className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">Operaciones</h6>
      </div>
      <div className="card-body">
        <table
          className="table table-striped table-hover w-auto display"
          ref={tableRef}
        />
      </div>
    </div>
  );
}

export default OperacionesCambioCuentasPorCobrar;
